import type { FC, ReactNode } from "react";
import { Redirect } from "react-router-dom";
import { isPageAllowed } from "src/utils/pageAccess";
import { isAdminUser } from "src/utils/permission";
import useAuth from "../hooks/useAuth";
import { isUserEnabled } from "../utils/shouldDisplayEntity";

interface AuthGuardAdminProps {
    children?: ReactNode;
}

const AuthGuardAdmin: FC<AuthGuardAdminProps> = ({ children }) => {
    const { user, isAuthenticated } = useAuth();

    if (!isAuthenticated || (user && !isUserEnabled(user))) {
        return <Redirect to="/login" />;
    }

    if (!isAdminUser(user)) {
        return <Redirect to="/403" />;
    }

    if (!isPageAllowed({ user, path: window.location.pathname })) {
        return <Redirect to="/404" />;
    }

    return <>{children}</>;
};

export default AuthGuardAdmin;
